import { ArrowLeftIcon, RotateCwIcon } from "lucide-react";
import HeaderWithInstagram from "./header/HeaderWithInstagram";
import { Button } from "./ui/button";
import { useNavigate, useRouteError } from "react-router-dom";
import { useTranslation } from "@/hooks/useTranslation";
import * as Sentry from "@sentry/react";
import { useQueryClient } from "@tanstack/react-query";
import { reloadApp } from "@/lib/reloadApp";

export function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const t = useTranslation();
  const queryClient = useQueryClient();

  console.error("Error caught by Router:", error);
  if (error instanceof Error) {
    Sentry.captureException(error);
  } else {
    Sentry.captureMessage("Unknown error caught by ErrorPage", {
      extra: { error },
    });
  }

  return (
    <div className="h-screen flex flex-col bg-black text-white">
      <HeaderWithInstagram />
      <div className="flex flex-grow items-center justify-center dark px-2">
        <div className="max-w-md w-full text-center p-6 border border-zinc-600 rounded-lg shadow-lg space-y-6">
          <h1 className="text-3xl font-bold mb-6">
            {t.ERROR_PAGE.LABELS.TITLE}
          </h1>
          <Button onClick={() => navigate(-1)} className="w-full">
            <ArrowLeftIcon className="w-4 h-4 mr-2" />
            {t.ERROR_PAGE.LABELS.GO_BACK}
          </Button>
          <Button
            onClick={() => reloadApp(queryClient, () => navigate(0))}
            className="w-full"
          >
            <RotateCwIcon className="w-4 h-4 mr-2" />
            {t.ERROR_PAGE.LABELS.TRY_AGAIN}
          </Button>
          <div className="text-sm text-gray-400 text-left">
            {t.SHARED.ERRORS.PERSISTENT}
          </div>
        </div>
      </div>
    </div>
  );
}
